import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import css_248z from './countries-list.scss.js';

class CountriesList extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
    }
    render() {
        const containerClassMap = {
            rtl: this.rtl,
        };
        return $ `<div class="countries-list ${o(containerClassMap)}"><slot name="list-items"></slot></div>`;
    }
}
CountriesList.styles = css_248z;
__decorate([
    e({ type: Boolean })
], CountriesList.prototype, "rtl", void 0);
customElements.define('countries-list', CountriesList);

export { CountriesList };
